module.exports = __webpack_public_path__ + "static/media/scan1Big.be77eabe.png";